import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'dashboard',
  initialState: {
    gridOpen: false,
    gridFilter: {
      deviceIds: [],
      deviceNames: [],
      filterLabel: '',
      colorIndex: 0,
    },
    activityFullScreen: false,
    loadingTimeline: false,
  },
  reducers: {
    openGrid(state, action) {
      state.gridOpen = true;
      state.gridFilter = action.payload;
    },
    closeGrid(state) {
      state.gridOpen = false;
    },
    setActivityFullScreen(state, action) {
      state.activityFullScreen = action.payload;
    },
    setLoadingTimeline(state, action) {
      state.loadingTimeline = action.payload;
    },
  },
});

export { actions as dashboardActions };
export { reducer as dashboardReducer };
